module.exports = __webpack_public_path__ + "img/user_placeholder_default.4b346f2c.png";